module.exports = __webpack_public_path__ + "img/SliderCutImg1.20ca8775.jpg";